<template>
  <div
    v-if="show"
    class="custom-inline-panel"
    :style="{
      top: `${top + currentScrollTop}px`,
      left: `${left + currentScrollLeft}px`,
      position: 'absolute'
    }"
  >

    <div class="max-h-[264px] overflow-auto flex flex-col rounded-md shadow-md p-[0.8rem] bg-white w-[282px] mx-auto ">

      <!-- Header Section -->
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <h3 class="text-[17px] font-semibold">Edit Board</h3>

          <a href="#" @click.prevent="navigateToAddNewBoard"
            class="text-blue-500 text-sm font-medium hover:underline add-new-state-link mb-[5px]">
            (+ Add New Board)
          </a>

          <fluent-icon
            v-tooltip="{
              content: 'If you want to add new board, click on (+ Add New Board) link.',
              trigger: 'hover',
            }"
            icon="info"
            size="16"
            class="info-color has-tooltip mb-[5px]"
          />

        </div>
      </div>

  
      <!-- Scrollable Clickable Board List -->
      <div class="mt-[0.4rem]">
        <input
        v-model="search"
        type="text"
        class="search-input w-full border border-gray-300 rounded-md px-1.5 py-0.5 text-sm mb-2"
        placeholder="Search board..."
         />
      </div>

  <div class="mt-2 max-h-40 overflow-y-auto">
   <LabelDropdownItem
    v-for="board in filteredBoards"
    :key="board.id"
    :title="board.name"
    :color="board.color"
    :selected="boardId === board.id"
    @click="selectBoard(board.id)"
  />
  <div
    v-if="noResult"
    class="text-sm text-gray-600 dark:text-white px-2 py-4 text-center"
  >
  No results found
  </div>
</div>


      <!-- Footer buttons -->
      <div class="flex gap-2 mt-[0.6rem] justify-end">

        <span v-if="selectedBoardName && board_id"
            class="ml-2 px-2 py-[0.15rem] text-sm inline-flex items-center max-w-[200px] overflow-hidden">
            <span class="text-gray-800 font-medium truncate max-w-[150px] overflow-hidden whitespace-nowrap">{{ selectedBoardName }}</span>
            <!-- <button @click="clearSelectedBoard" class=" cancel-cross ml-1 mb-1 text-gray-600 hover:text-black text-xl leading-none cursor-pointer px-[0.4rem]">&times;</button> -->
            <woot-button
    icon="delete"
    variant="smooth"
    size="small"
    @click="clearSelectedBoard"
    class="action-button black-icon"
  />
          </span>
        <button class="cancel-btn px-4 py-2 rounded border cursor-pointer" @click.prevent="onCancel">
          {{ $t('CONTACT_FORM.FORM.CANCEL') }}
        </button>
      </div>
    </div>
  </div>
</template>

    
<script>
import Editor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import LabelDropdownItem from 'shared/components/ui/label/LabelDropdownItem.vue';
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import { picoSearch } from '@scmmishra/pico-search';

export default {
  components: {
    Editor,
    LabelDropdownItem,
  },
  props: {
    show: { type: Boolean, default: false },
    board_id: { type: Number, default: null },
    contactId: { type: Number, default: null },
    top: Number,
    left: Number,
    currentScrollLeft: { type: Number, default: 0 },
    currentScrollTop: { type: Number, default: 0 }
  },
  mixins: [alertMixin],
  data() {
    return {
      boardId: null,
      progress: false,
      originalBoardId: null,
      search: '',
      statusId: null,
      statuss: [],
      remark: '',
    };
  },
  // watch: {
  //   board_id(newVal) {
  //     this.boardId = newVal;
  //     if (newVal != null) {
  //       this.getBoardData(newVal);
  //     } else {
  //       this.boardId = null;
  //     }
  //   },
  // },
  watch: {
  board_id: {
    handler(newVal) {
      this.boardId = newVal;
      if (newVal != null) {
        this.getBoardData(newVal);
      } else {
        this.boardId = null;
      }
    },
    immediate: true 
  },
  
  contactId: {
    handler(newVal) {
      // When contact changes, reset boardId to contact's assigned board
      this.boardId = this.board_id; 
      if (this.boardId != null) {
        this.getBoardData(this.boardId);
      }
    },
    immediate: true
  },
  boards: {
    handler(newBoards) {
      if (this.boardId && newBoards && newBoards.length > 0) {
        this.$forceUpdate();
      }
    },
    immediate: true
  },
   // Add watcher for show prop to handle outside click
   show(newVal) {
      if (newVal) {
        this.isModalOpening = true;
        // Use nextTick and small timeout to ensure DOM is updated and prevent immediate closure
        this.$nextTick(() => {
          setTimeout(() => {
            this.isModalOpening = false;
            document.addEventListener('click', this.handleOutsideClick);
          }, 100);
        });
      } else {
        document.removeEventListener('click', this.handleOutsideClick);
      }
    }
},
  mounted() {
    this.setInitialValues();
    this.$store.dispatch('pipelines/getBoards');
     
  if (this.board_id) {
    this.boardId = this.board_id;
  }
  },
  beforeDestroy() {
    // Clean up event listener when component is destroyed
    document.removeEventListener('click', this.handleOutsideClick);
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
    }),
    boards() {
      return this.$store.getters['pipelines/getAllBoards'];
    },
    filteredBoards() {
      const filtered = !this.search
        ? this.boards
        : picoSearch(this.boards, this.search, ['name'], { threshold: 0.5 });
      return filtered.filter(board => board.id !== this.boardId);
    },
    noResult() {
      return this.filteredBoards.length === 0 && this.search.trim() !== '';
    },
    selectedBoardName() {
      if (!this.boardId || !this.boards || this.boards.length === 0) {
      return '';
    }
      const board = this.boards.find(b => b.id === this.boardId);
      return board ? board.name : '';
    },
    formHasChanged() {
      return this.boardId !== this.originalBoardId;
    },
  },
  methods: {
    handleOutsideClick(event) {
      if (!this.show || this.isModalOpening) return;
      const modalElement = this.$el;
      if (modalElement && !modalElement.contains(event.target)) {
        this.onCancel();
      }
    },
    selectBoard(id) {
      this.boardId = id;
      this.$emit('update:board_id', id);
      console.log('Selected board ID:', id);
      this.onBoardChange();
    },

    async onBoardChange() {
      if (this.boardId) {
        await this.createBoard();
        console.log('Board is being updated:', this.boardId);
        await this.fetchStatuses(this.boardId);
        if (this.statuss && this.statuss.length > 0) {
          // this.selectStatus(this.statuss[0].id);
          this.$emit('first-status-selected', this.statuss[0].id);
        }
      }
    },

    async fetchStatuses(boardId) {
      try {
        console.log("invoking fetchStatuses",this.accountId);
        const response = await axios.get(
          `/api/v1/accounts/${this.accountId}/statuses`,
          {
            headers: {
              'Content-Type': 'application/json',
              'api-access-token': this.currentUser.access_token,
            },
            params: { board_id: boardId },
          }
        );
        this.statuss = response.data.data;
        console.log('Statuses fetched:', this.statuss);
      } catch (error) {
        console.error('Error fetching statuses:', error);
      }
    },

    // selectStatus(id) {
    //   this.statusId = id;
    //   this.onStatusChange();
    // },

    // async onStatusChange() {
    //   if (this.statusId) {
    //     console.log('Status is being updated:', this.statusId);
    //     await this.editStatus();
    //   }
    // },

    // async editStatus() {
    //   const data = {
    //     statusId: this.statusId,
    //     contactId: this.contactId,
    //     description: this.remark,
    //   };
    //   // const response = await this.$store.dispatch('pipelines/assignStatus', data);
    //   // bus.$emit('on-assign');
    //   // if (response.status === 200) {
    //   //   this.showAlert('Status Update Successfully', { success: true });
    //   // }
    // },

    async removeStatus() {
      this.progress = true;
      const data = {
        statusId: null, 
        contactId: this.contactId,
        description: '',
      };
      const response = await this.$store.dispatch(
        'pipelines/assignStatus',
        data
      );
      bus.$emit('on-assign');
      this.onCancel();
      this.progress = false;
    },

    navigateToAddNewBoard() {
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      if (!this.accountId) {
        console.error('Account ID is undefined');
        return;
      }
      const url = `${baseUrl}/app/accounts/${this.accountId}/settings/board?showAddBoard=true`;
      this.onCancel();
      window.open(url, '_blank');
    },

    onCancel() {
      this.search = ''
      document.removeEventListener('click', this.handleOutsideClick);
      this.$emit('cancel');
    },

    async getBoardData(board_id) {
      console.log('getBoardData called');
      const response = await this.$store.dispatch('contacts/getBoard', board_id);
      console.log('Response', response);
      this.setInitialValues();
    },

    setInitialValues() {
      this.originalBoardId = this.boardId;
    },

    async createBoard() {
      this.progress = true;
      const data = {
        boardId: this.boardId,
        contactId: this.contactId,
        description: this.remark,
      };
      console.log('Data::::', data);
      const response = await this.$store.dispatch('contacts/assignBoard', data);
      bus.$emit('on-assign');
      if (response.status === 200) {
        this.showAlert('Board Update Successfully', { success: true });
      }
      this.onCancel();
      this.progress = false;
    },

    async removeBoard() {
      this.progress = true;
      const data = {
        boardId: null,
        contactId: this.contactId,
      };
      console.log('Removing board data:', data);
      const response = await this.$store.dispatch('contacts/assignBoard', data);
      bus.$emit('on-assign');
      if (response.status === 200) {
        this.showAlert('Board Removed Successfully', { success: true });
      }
      this.onCancel();
      this.progress = false;
    },

    async clearSelectedBoard() {
      this.boardId = null;
      this.$emit('update:board_id', null);
      await this.removeBoard();
      await this.removeStatus();
    },

    backUrl() {
      this.$router.push({ name: 'settings_account_reports' });
    },
  },
};
</script>

    
<style lang="scss" scoped>
.custom-inline-panel {
  z-index: 1; // Ensure modal appears above table content
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2); // Make modal stand out
}

.justify-item {
  justify-content: space-around;
}
.button-color {
  background-color: #40518a;
}
.color {
  color: #40518a;
}
.editor-ui {
  border: 2px solid lightgrey;
  margin: 0px 7px;
  height: 200px;
  padding-left: 10px;
}
.cancel-btn{
    background-color: #fff;
    color: #40518a;
  }
  .cancel-btn:hover{
    background-color: #F9F9F9;
    color: #40518a;
  }
  /* Padding for Header */
.px-8 {
  padding-left: 1rem;
}

/* Styling for Add New State Link */
.add-new-state-link {
  // position: absolute;
  // top: 45px;
  // left: 137px;
  color: #40518a;
  font-size: 0.875rem; /* text-sm */
  font-weight: 500; /* font-medium */
  text-decoration: none;
}

.add-new-state-link:hover {
  text-decoration: underline;
  color: #0056b3;
}

/* Styling for Info Icon */
.info-icon-3 {
  position: absolute;
  top: 45px;
  right: 316px;
  // color: #40518a;
}

.info-icon:hover {
  color: #40518a;
}
.info-color{
  color:black;
}
.board-list {
  max-height: 10rem;
  overflow-y: auto;
}
// .cancel-cross:hover{
//   color: #369EFF;
// }
.action-button {
  background: none !important;
  width: auto !important;
  color: #413f3f;
  margin-left:5px;
}

.dark .action-button{
  color: #3C4858;
}
.dark .text-gray-800 {
  color: #3C4858;
}

</style>